import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Stack from "@mui/material/Stack";
import { alpha } from "@mui/material/styles";
export function toIsoDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
export function DateStrip({ value, onChange, days, disabled }) {
    const dates = React.useMemo(() => Array.from({ length: days }, (_, offset) => {
        const day = new Date();
        day.setDate(day.getDate() + offset);
        return day;
    }), [days]);
    return (_jsx(Stack, { direction: "row", spacing: 1, sx: {
            overflowX: "auto",
            pb: 1,
            mb: 2,
            scrollbarWidth: "thin",
            WebkitOverflowScrolling: "touch",
        }, children: dates.map((day) => {
            const iso = toIsoDate(day);
            const selected = iso === value;
            return (_jsxs(ButtonBase, { onClick: () => onChange(iso), disabled: disabled, "aria-pressed": selected, sx: (theme) => ({
                    flexShrink: 0,
                    minWidth: { xs: 56, sm: 62 },
                    py: 1,
                    borderRadius: 2,
                    flexDirection: "column",
                    border: `1px solid ${selected
                        ? theme.palette.primary.main
                        : theme.palette.divider}`,
                    color: selected
                        ? theme.palette.primary.contrastText
                        : theme.palette.text.primary,
                    backgroundColor: selected
                        ? theme.palette.primary.main
                        : theme.palette.background.paper,
                    transition: "background-color 140ms ease, border-color 140ms ease",
                    "&:hover": {
                        borderColor: theme.palette.primary.main,
                        backgroundColor: selected
                            ? theme.palette.primary.dark
                            : alpha(theme.palette.primary.main, 0.06),
                    },
                    "&.Mui-disabled": { opacity: 0.5 },
                    "&:focus-visible": {
                        outline: `2px solid ${theme.palette.primary.main}`,
                        outlineOffset: 2,
                    },
                    "@media (prefers-reduced-motion: reduce)": {
                        transition: "none",
                    },
                }), children: [_jsx(Box, { sx: {
                            fontSize: 10,
                            fontWeight: 700,
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                            opacity: selected ? 0.85 : 0.6,
                            lineHeight: 1.4,
                        }, children: day.toLocaleDateString(undefined, { weekday: "short" }) }), _jsx(Box, { sx: { fontSize: 17, fontWeight: 700, lineHeight: 1.3 }, children: day.toLocaleDateString(undefined, { day: "numeric" }) })] }, iso));
        }) }));
}
